export const DATA_QA_PDP_COMPARISON_COMPARE_BUTTON = 'pdp-comparison-compare-button';
export const GA_REMOVE_FROM_COMPARISON_LIST = 'GA:removeFromComparisonList';
export const GA_ADD_TO_COMPARISON_LIST = 'GA:addToComparisonList';
